import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate, currencyFormat } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import { useNavigate } from 'react-router-dom';
import useAxios from 'hooks/useAxios';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import DragDrop from 'components/DragDrop';


let autoselectlist1 = [];
let currencylist = ['Total Ordered Price', 'Total Invoiced Price'];
let dateList = ['PO Date'];
let numberlist = ['PO Number', 'Source PO#', 'Total Packages Ordered', 'Total Ordered Price', 'Total Invoiced Packages']
let hideColFilterlist = ['PO Date', 'Total Ordered Price', 'PO Number', 'Source PO#',]
let isRole = ["GWPHA", "GWPHU"]
let tableDataBackup = [];
const ReportInvoicedClaimsTable = (props) => {
  const {
    data,
    loading,
    totalSize,
    onPageChange,
    filters,
    onSearchColumnFilters = () => '',
    onExport,
    thirdPartyAdmin,
    enableAdd,
    refetch,
    toggleSider,
    collapseSider,
  } = props;
  const API = useAxios();
  tableDataBackup = data;
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(tableDataBackup);
  const [reset, setReset] = useState(false);
  const { token_type, access_token, profile } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  const [isOpen, setIsOpen] = useState(false);
  const [coloumselect, setColoumselect] = useState(false);
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: filters,
  });
  const { roles } = profile || {};
  console.log(roles, "roles")
  var con = isRole.includes(roles);
  console.log(con, "con")
  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  useEffect(() => {


    handlAutocoloms();

  }, []);
  const handlAutocoloms = async () => {
    autoselectlist1 = [];
    try {
      const { data } = await API.get(`GWConfig/coveredentity/autoselectcoloumslist`, {
        hasDefaultURL: true,
      });
      if (data) {
        for (var x in data) {
          autoselectlist1.push({ "text": data[x].displayName, "dataField": data[x].fieldName });

        }
      }

    } catch (err) {

    }
  }
  const handleselectColoums = () => {
    setColoumselect(!coloumselect);
  }
  const { filters: colFilter, backUpData } = state;


  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };

  const handleFilterCancel = () => {
    refetch();
  };
  const cellRenderLink = (rowData) => {
    return (
      <span
        className='text-decoration-underline d-inline-block cursor-pointer'
        onClick={() => handlePODetails(rowData)}
      >
        {rowData.poid}
      </span>
    );
  };
  const cellOptionLink = (rowData) => {
    if (rowData.poStatusID == 5070) {
      return (
        <Button color='link' onClick={() => handleClaimsPO(rowData)}>
          <HoverImage src={ViewClaimsHover} hoverSrc={ViewClaimsHover} alt />
        </Button>
      );
    }

  };

  let maincol1 = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellOptionLink(rowData),
      action: true,
    },
    {
      dataField: autoselectlist1[0]?.dataField,
      text: autoselectlist1[0]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[0]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[0]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[0]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 0 ? true : false,
      inputType: dateList.includes(autoselectlist1[0]?.text) ? "date" : numberlist.includes(autoselectlist1[0]?.text) ? "number" : "text",
      width: 144,
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[1]?.dataField,
      text: autoselectlist1[1]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[1]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[1]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[1]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 144,
      show: autoselectlist1.length > [1] ? true : false,
      inputType: dateList.includes(autoselectlist1[1]?.text) ? "date" : numberlist.includes(autoselectlist1[1]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[2]?.dataField,
      text: autoselectlist1[2]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[2]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[2]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[2]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [2] ? true : false,
      inputType: dateList.includes(autoselectlist1[2]?.text) ? "date" : numberlist.includes(autoselectlist1[2]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[3]?.dataField,
      text: autoselectlist1[3]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[3]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[3]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[3]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [3] ? true : false,
      inputType: dateList.includes(autoselectlist1[3]?.text) ? "date" : numberlist.includes(autoselectlist1[3]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
      action: true,
      width: 144,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[4]?.dataField,
      text: autoselectlist1[4]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[4]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[4]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[4]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [4] ? true : false,
      inputType: dateList.includes(autoselectlist1[4]?.text) ? "date" : numberlist.includes(autoselectlist1[4]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[5]?.dataField,
      text: autoselectlist1[5]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[5]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[5]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[5]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [5] ? true : false,
      inputType: dateList.includes(autoselectlist1[5]?.text) ? "date" : numberlist.includes(autoselectlist1[5]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[6]?.dataField,
      text: autoselectlist1[6]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[6]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[6]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[6]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [6] ? true : false,
      inputType: dateList.includes(autoselectlist1[6]?.text) ? "date" : numberlist.includes(autoselectlist1[6]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[7]?.dataField,
      text: autoselectlist1[7]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[7]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[7]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[7]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [7] ? true : false,
      inputType: dateList.includes(autoselectlist1[7]?.text) ? "date" : numberlist.includes(autoselectlist1[7]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[8]?.dataField,
      text: autoselectlist1[8]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[8]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[8]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[8]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]), width: 80,
      show: autoselectlist1.length > [8] ? true : false,
      inputType: dateList.includes(autoselectlist1[8]?.text) ? "date" : numberlist.includes(autoselectlist1[8]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[9]?.dataField,
      text: autoselectlist1[9]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[9]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[9]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[9]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [9] ? true : false,
      inputType: dateList.includes(autoselectlist1[9]?.text) ? "date" : numberlist.includes(autoselectlist1[9]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[10]?.dataField,
      text: autoselectlist1[10]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[10]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[10]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[10]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [10] ? true : false,
      inputType: dateList.includes(autoselectlist1[10]?.text) ? "date" : numberlist.includes(autoselectlist1[10]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[11]?.dataField,
      text: autoselectlist1[11]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[11]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[11]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[11]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [11] ? true : false,
      inputType: dateList.includes(autoselectlist1[11]?.text) ? "date" : numberlist.includes(autoselectlist1[11]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[12]?.dataField,
      text: autoselectlist1[12]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[12]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[12]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[12]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [12] ? true : false,
      inputType: dateList.includes(autoselectlist1[12]?.text) ? "date" : numberlist.includes(autoselectlist1[12]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,

    },
    {
      dataField: autoselectlist1[13]?.dataField,
      text: autoselectlist1[13]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[13]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[13]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[13]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [13] ? true : false,
      inputType: dateList.includes(autoselectlist1[13]?.text) ? "date" : numberlist.includes(autoselectlist1[13]?.text) ? "number" : "text",

      hideColFilter: !hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[14]?.dataField,
      text: autoselectlist1[14]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[14]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[14]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[14]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [14] ? true : false,
      inputType: dateList.includes(autoselectlist1[14]?.text) ? "date" : numberlist.includes(autoselectlist1[14]?.text) ? "number" : "text",

      hideColFilter: !hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[15]?.dataField,
      text: autoselectlist1[15]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[15]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[15]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[15]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [15] ? true : false,
      inputType: dateList.includes(autoselectlist1[15]?.text) ? "date" : numberlist.includes(autoselectlist1[15]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[16]?.dataField,
      text: autoselectlist1[16]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[16]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[16]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[16]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [16] ? true : false,
      inputType: dateList.includes(autoselectlist1[16]?.text) ? "date" : numberlist.includes(autoselectlist1[16]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
      width: 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
    },
  ];
  let mainCol = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 70,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellOptionLink(rowData),
      action: true,
    },

    {
      dataField: 'coveredEntity',
      text: 'Covered Entity',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRendererCheck(rowData),
    },

    {
      dataField: 'pharmacyName',
      text: 'Pharmacy Name',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'storeNPI',
      text: 'Pharmacy NABP or NPI',
      sort: true,
      width: 165,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'transactionCode',
      text: 'Transaction Code',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'insuranceMemberID',
      text: 'Insurance Member ID',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'bin',
      text: 'BIN',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'pcn',
      text: 'PCN',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'group',
      text: 'Group',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'secondaryBIN',
      text: 'Secondary BIN',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'secondaryPCN',
      text: 'Secondary PCN',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'secondaryGroupNumber',
      text: 'Secondary Group Number',
      sort: false,
      width: 175,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'occ',
      text: 'Other Coverage Code',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'scc',
      text: 'Submission Clarification Code',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'prescriptionNumber',
      text: 'Rx #',
      sort: true,
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'fillNumber',
      text: 'Refill #',
      sort: true,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

    {
      dataField: 'switchDate',
      text: 'Switch Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },

    {
      dataField: 'writtenDate',
      text: 'Written Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),

    },

    {
      dataField: 'switchDate',
      text: 'Switch Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: 'switchDate',
      text: 'Switch Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: 'switchDate',
      text: 'Switch Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: 'switchDate',
      text: 'Switch Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    }

  ];



  return (
    <div>
    <h5 className="f-16 text-primary font-weight-700">
      Report Invoiced Claim Count ({totalSize})
    </h5>
    <hr />
    <div
      className="table-card scroll-table position-relative border-0 rounded pt-0"
      fixed-height={backUpData.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id='Invoice-table'
        fixedColumn
        data={backUpData}
        loading={loading}
        columns={columns}
        onPageSizeChange={onPageSizeChange}
        pageSize={colFilter.pageSize}
        onExport={onExport}
        hasPagination
        onPageChange={onHandlePageChange}
        currentPage={colFilter.currentPage}
        totalRecords={totalSize}
        handleSort={onHandleSort}
        filters={colFilter}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
        onSelectColoums={handleselectColoums}
        autoselectlist1={autoselectlist1}
        hasColselect={true}
        toggleSider={toggleSider}
        enabletogglesider={true}
        collapseSider={collapseSider}
      />
      <Modal
        isOpen={coloumselect}
        toggle={handleselectColoums}
        size='lg'
        className='lg'
      >
        <ModalHeader toggle={handleselectColoums}>
          Column Selector
        </ModalHeader>
        <ModalBody>
          <DragDrop cancalcolselect={handleselectColoums} refetch={handleFilterCancel} reloadautocoloum={handlAutocoloms} />
        </ModalBody>
      </Modal>
    </div>
    </div>
  )
}

export default ReportInvoicedClaimsTable;
